import styled from 'styled-components';

const TooltipMessage = styled.div`
  background: rgba(0, 0, 0, .7);
  border-radius: 3px;
  color: #FFF;
  font-size: .75rem;
  line-height: 1.4;
  padding: .75em;
  text-align: center;
`;

export default TooltipMessage;
